
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Subscriptions',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllCategories();
        await this.GetAllManufacturers();
        await this.loadStockingList();
        await this.loadDepartmentList();

        if (!this.loginDetails || !this.canViewStockingsUi())
            this.logout();

        if (this.$route.query.search) {
            this.Search = String(this.$route.query.search);
        }

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        statsCards() {
            const totalPrice = Number(this.Statistics && this.Statistics.price) || 0;
            return [
                this.statCard('إجمالي السجلات', this.Statistics && this.Statistics.count, 'primary', 'ti ti-stack-2'),
                {
                    title: 'إجمالي القيمة',
                    value: `${this.formatNumber(totalPrice)} د.ل`,
                    tone: 'success',
                    icon: 'ti ti-cash',
                },
                this.statCard('أصناف قاربت الصلاحية', this.Statistics && this.Statistics.productExpiryCount, 'danger', 'ti ti-alert-circle'),
                this.statCard('التصنيفات المغطاة', this.Statistics && this.Statistics.categoriesCount, 'info', 'ti ti-category'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',
            stockingList: [],
            stockingFilter: '',
            departmentList: [],
            departmentFilter: '',

            ScreenTitle: 'تشغيلات وأرصدة الأصناف',
            ScreenTitleSingle: 'رصيد',
            ScreenTitleSingleAl: 'الرصيد',

            Info: [],
            Statistics: [],
            Manufacturers: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                CategoriesId: '',
                ManufacturerId: '',
                BatchNumber: '',
                Model: '',
                Material: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
            },
            rules: {
                Name: this.$helper.Required(),
                CategoriesId: this.$helper.Required(),
                BatchNumber: this.$helper.Required(),
            },






        };
    },



    methods: {
        tableRowNumber(index) {
            return ((this.pageNo || 1) - 1) * (this.pageSize || 10) + index + 1;
        },
        tradeName(item) {
            if (!item) return '—';
            return item.tradeName || item.productName || item.name || '—';
        },
        nationalFormularyName(item) {
            if (!item) return '—';
            const name = item.nationalFormularyName || item.scientificName;
            return name && String(name).trim() ? String(name).trim() : '—';
        },
        batchLabel(item) {
            if (!item) return '—';
            return item.batchNumber || item.serialNumber || '—';
        },
        lineValue(item) {
            if (!item) return 0;
            if (item.totalValue != null) return Number(item.totalValue) || 0;
            const qty = Number(item.quantity) || 0;
            const price = Number(item.unitPrice != null ? item.unitPrice : item.price) || 0;
            return qty * price;
        },
        formatCurrency(value) {
            const n = Number(value) || 0;
            return n.toLocaleString('ar', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' د.ل';
        },
        expiryBadgeClass(item) {
            const state = this.expiryState(item);
            if (state === 'expired') return 'bg-label-danger';
            if (state === 'warning') return 'bg-label-warning';
            return 'bg-label-success';
        },
        expiryBadgeLabel(item) {
            const state = this.expiryState(item);
            if (state === 'expired') return 'منتهي';
            if (state === 'warning') return 'قريب الانتهاء';
            return 'صالح';
        },
        expiryState(item) {
            if (!item || !item.expiryDate) return 'ok';
            const expiry = new Date(item.expiryDate);
            const today = new Date();
            const diffDays = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
            if (diffDays < 0) return 'expired';
            if (diffDays <= 90) return 'warning';
            return 'ok';
        },
        stockLocation(item) {
            const stocking = item && item.stockingName ? item.stockingName : 'بدون مخزن';
            const department = item && item.departmentName ? item.departmentName : 'بدون قسم';
            return `${stocking} - ${department}`;
        },
        formularyCategoryName(item) {
            const name = item && (item.categoryName || item.categories);
            return name && String(name).trim() ? String(name).trim() : 'بدون تصنيف';
        },
        productMeta(item) {
            const serial = item && item.serialNumber ? item.serialNumber : null;
            const category = this.formularyCategoryName(item);
            return serial ? `${category} · ${serial}` : category;
        },

        GetAllManufacturers() {
            return this.$http.GetAllManufacturers()
                .then((response) => {
                    this.Manufacturers = response.data.info || [];
                })
                .catch(() => {
                    this.Manufacturers = [];
                });
        },

        loadStockingList() {
            return this.$http.GetAllStocking()
                .then((r) => {
                    let list = r.data.info || [];
                    if (this.loginDetails && this.isFacilityCenterRole && this.isFacilityCenterRole() && this.loginDetails.branchesId) {
                        const bid = this.loginDetails.branchesId;
                        list = list.filter((s) => s.branchesId === bid);
                    }
                    this.stockingList = list;
                })
                .catch(() => {
                    this.stockingList = [];
                });
        },

        loadDepartmentList() {
            return this.$http.GetAllFacilityDepartments()
                .then((r) => {
                    this.departmentList = r.data.info || [];
                })
                .catch(() => {
                    this.departmentList = [];
                });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetProductsCounts(this.pageNo, this.pageSize, this.Search, this.stockingFilter, this.departmentFilter)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.Statistics = [];
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = {
                        ...this.ruleForm,
                        Id: Number(0),
                        ManufacturerId: this.ruleForm.ManufacturerId === '' ? null : this.ruleForm.ManufacturerId,
                    };
                    this.$blockUI.Start();
                    this.$http.AddProducts(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();

                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions;
            this.ruleForm.ManufacturerId = item.manufacturerId;
            this.ruleForm.Model = item.model;
            this.ruleForm.Material = item.material;
            this.ruleForm.CategoriesId = item.categoriesId;
            this.ruleForm.BatchNumber = item.batchNumber;
        },

        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = {
                        ...this.ruleForm,
                        Id: Number(this.ruleForm.Id),
                        ManufacturerId: this.ruleForm.ManufacturerId === '' ? null : this.ruleForm.ManufacturerId,
                    };
                    this.$blockUI.Start();
                    this.$http.EditProducts(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة الحساب  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusProducts(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteProducts(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },



        //Support Info
        Back() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },


    }
}
